export const USE_GET_INFOR_USER = 'use_get_infor_user';
export const USE_GET_PERMISSION_USER_IN_BO = 'USE_GET_PERMISSION_USER_IN_BO';
export const USE_GET_PERMISSION_USER_IN_WORKFLOW = 'USE_GET_PERMISSION_USER_IN_WORKFLOW';
